// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import moment from "moment-timezone";
// import MasterLayout from "../../../masterLayout/MasterLayout";
// import axios from "axios";
// import { baseUrl } from "../../../helper/urls";
// import CustomTable from "../../../components/custom_table/CustomTable";
// import { createMRTColumnHelper } from "material-react-table";
// import { Box, Button, Chip, IconButton, Stack, Tooltip } from "@mui/material";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import { toast, ToastContainer } from "react-toastify";
// import Swal from "sweetalert2";
// import EventRepeatIcon from "@mui/icons-material/EventRepeat";
// import { useNavigate } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";

// export default function ScheduledBookingList() {
//   const { token } = useSelector((state) => state.auth);
//   const navigate = useNavigate();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await axios.get(
//         `${baseUrl}/bookings/getBookingUpComing`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const timezoneConverted = convertSlotsToStudentTimezone(
//         response.data.data || []
//       );

//       // Add formattedReqId here
//       const processedData = timezoneConverted.map((item) => ({
//         ...item,
//         formattedReqId: `DDR000${item.reqId || ""}`,
//         counselorName: `${item.c_firstname || ""} ${
//           item.c_lastname || ""
//         }`.trim(),
//       }));

//       setData(processedData);
//     } catch (err) {
//       console.error("Failed to fetch bookings", err);
//       setError("Failed to fetch bookings. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const convertSlotsToStudentTimezone = (slots) => {
//     const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//     return slots.map((slot) => {
//       const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
//       const endLocal = moment(startLocal).add(slot.booking_duration, "minutes");
//       return {
//         ...slot,
//         booking_date: startLocal.format("YYYY-MM-DD"),
//         start_time: startLocal.format("hh:mm A"),
//         end_time: endLocal.format("hh:mm A"),
//         time_zone: studentTimeZone,
//       };
//     });
//   };

//   const handleReschedule = (rowData) => {
//     Swal.fire({
//       html: `<h4 style="font-size:14px; margin-bottom: 10px; padding:20px;">Reschedule Booking</h4>
//              <p>Please provide a reason for rescheduling:</p>`,
//       input: "text",
//       inputPlaceholder: "Enter reason here...",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Reschedule",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       preConfirm: (reason) => {
//         if (!reason) {
//           Swal.showValidationMessage("Reason is required.");
//         }
//         return reason;
//       },
//     }).then((result) => {
//       if (result.isConfirmed) {
//         const payload = {
//           slotId: rowData.slotId,
//           counselorId: rowData.counselorId,
//           bookedId: rowData.id,
//           reason: result.value,
//         };

//         axios
//           .post(`${baseUrl}/api/reschedule/student/create`, payload, {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           })
//           .then(() => {
//             Swal.fire({
//               html: `
//                 <h4 style="font-size:16px; margin-bottom: 10px;">Rescheduled!</h4>
//                 <p style="font-size:16px;">The reschedule request has been sent to the counselor.</p>
//               `,
//               icon: "success",
//             });
//             fetchData();
//           })
//           .catch((error) => {
//             const message =
//               error.response?.data?.message ||
//               error.message ||
//               "Failed to reschedule.";
//             Swal.fire("Error", message, "error");
//           });
//       }
//     });
//   };

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("meet_link", {
//       header: "Meet Link",
//       size: 30,
//       Cell: (cell) => {
//         const link = cell.row.original?.meet_link;
//         const rescheduleId = cell.row.original?.rescheduleId;

//         if (rescheduleId || !link) return "-";

//         const handleCopy = async () => {
//           try {
//             await navigator.clipboard.writeText(link);
//             toast.success("Link copied to clipboard!");
//           } catch (err) {
//             console.error("Failed to copy:", err);
//           }
//         };

//         return (
//           <Stack direction="row" spacing={1}>
//             <Tooltip title="Copy Link">
//               <IconButton size="small" onClick={handleCopy}>
//                 <ContentCopyIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Open Link">
//               <IconButton
//                 size="small"
//                 onClick={() => window.open(link, "_blank")}
//               >
//                 <OpenInNewIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//           </Stack>
//         );
//       },
//     }),

//     columnHelper.accessor("counselorName", {
//       header: "Counselor Name",
//       size: 40,
//     }),

//     columnHelper.accessor("booking_date", {
//       header: "Slot Date",
//       size: 20,
//     }),

//     columnHelper.accessor("start_time", {
//       header: "Start Time",
//       size: 20,
//     }),

//     columnHelper.accessor("end_time", {
//       header: "End Time",
//       size: 20,
//     }),

//     columnHelper.accessor("formattedReqId", {
//       header: "Request ID",
//       size: 20,
//     }),
//   ];

//   columns.unshift(
//     columnHelper.accessor("actions", {
//       header: "Actions",
//       Cell: ({ cell }) => {
//         const rowData = cell.row.original;
//         const { status, rescheduleId, newbookedId, createdAt, updatedAt } =
//           rowData;

//         const baseTime = createdAt || updatedAt;
//         const createdTime = moment(baseTime).toDate();
//         const now = new Date();
//         const timeDiffInHours = (now - createdTime) / (1000 * 60 * 60);
//         const canReschedule = timeDiffInHours >= 24;

//         return (
//           <Box>
//             {rescheduleId && status === 0 ? (
//               <Button variant="outlined" color="success" size="small" disabled>
//                 In-Progress approval
//               </Button>
//             ) : rescheduleId && status === 2 && !newbookedId ? (
//               <Button
//                 variant="contained"
//                 size="small"
//                 sx={{ backgroundColor: "#28a745", color: "white" }}
//                 onClick={() => {
//                   navigate("/student-slot-booking", {
//                     state: {
//                       counselorId: rowData.counselorId,
//                       studentId: rowData.studentId,
//                       reqId: rowData.reqId,
//                       UnscheduledSlot: 1,
//                       rescheduleId: rowData.rescheduleId,
//                     },
//                   });
//                 }}
//               >
//                 Reschedule Slot
//               </Button>
//             ) : !rescheduleId && !newbookedId ? (
//               <Tooltip
//                 title={
//                   canReschedule ? "Reschedule" : "Available after 24 hours"
//                 }
//                 arrow
//               >
//                 <span>
//                   <IconButton
//                     onClick={() => handleReschedule(rowData)}
//                     disabled={!canReschedule}
//                     sx={{
//                       color: canReschedule ? "red" : "gray",
//                       pointerEvents: canReschedule ? "auto" : "none",
//                     }}
//                   >
//                     <EventRepeatIcon />
//                   </IconButton>
//                 </span>
//               </Tooltip>
//             ) : rescheduleId && status === 2 && newbookedId ? (
//               <Button variant="outlined" color="success" size="small" disabled>
//                 Already Rescheduled
//               </Button>
//             ) : null}
//           </Box>
//         );
//       },
//     })
//   );

//   return (
//     <MasterLayout>
//       <ToastContainer position="top-right" autoClose={2000} />
//       {error && (
//         <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>
//       )}
//       <CustomTable columns={columns} data={data} loading={loading} />
//     </MasterLayout>
//   );
// }

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import MasterLayout from "../../../masterLayout/MasterLayout";
import axios from "axios";
import { baseUrl } from "../../../helper/urls";
import CustomTable from "../../../components/custom_table/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { Box, Button, Chip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { IconButton, Stack, Tooltip } from "@mui/material";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { useNavigate } from "react-router-dom";
export default function ScheduledBookingList() {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${baseUrl}/bookings/getBookingUpComing`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = convertSlotsToStudentTimezone(response.data.data || []);
      setData(data);
    } catch (err) {
      console.error("Failed to fetch pending booking list", err);
      setError("Failed to fetch pending bookings. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function formatUtcTimeTo12Hour(timeStr) {
    if (!timeStr) return "N/A";
    const d = new Date(timeStr);
    let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
  }

  function formatUtcTimeTo12HourAdd1hour(timeStr) {
    if (!timeStr) return "N/A";
    const d = new Date(timeStr);
    d.setUTCHours(d.getUTCHours() + 1); // Add 1 hour
    let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
  }
const getTimeZoneAbbreviation = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment.tz(timeZone).format("z");
};
const timeZoneAbbreviation = getTimeZoneAbbreviation();
  const convertSlotsToStudentTimezone1 = (utcTime, type, duration = 60) => {
    if (!utcTime || !type) return "Invalid input";

    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startLocal = moment.utc(utcTime).tz(studentTimeZone);
    const tzAbbr = startLocal.format("z"); 
    console.log('clllllllll',studentTimeZone,tzAbbr)
    const endLocal = moment(startLocal).add(duration, "minutes");

    switch (type) {
      case "date":
        return startLocal.format("YYYY-MM-DD");
      case "start":
        return startLocal.format("hh:mm:ss A");
      case "end":
        return endLocal.format("hh:mm:ss A");
      default:
        return "Invalid type";
    }
  };



  const convertSlotsToStudentTimezone = (slots) => {
    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return slots.map((slot) => {
      // const duration = slot.duration || 60;
      const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
      const endLocal = moment(startLocal).add(slot.booking_duration, "minutes");
      console.log(slot.booking_duration);
      return {
        ...slot,
        booking_date: startLocal.format("YYYY-MM-DD"),
        start_time: startLocal.format("hh:mm A"),
        end_time: endLocal.format("hh:mm A"),
        time_zone: studentTimeZone,
      };
    });
  };
  const handleReschedule = (rowData) => {
    Swal.fire({
      // title: "Reschedule Booking",
      // text: "Please provide a reason for rescheduling:",
      html: `<h4 style="font-size:14px; margin-bottom: 10px; padding:20px;">Reschedule Booking</h4>
         <p>Please provide a reason for rescheduling:</p>`,
      input: "text",
      inputPlaceholder: "Enter reason here...",
      inputAttributes: {
        name: "reason",
      },
      showCancelButton: true,
      confirmButtonText: "Yes, Reschedule",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      preConfirm: (reason) => {
        if (!reason) {
          Swal.showValidationMessage("Reason is required.");
        }
        return reason;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          slotId: rowData.slotId, // slot ID for the new time
          counselorId: rowData.counselorId, // student ID
          bookedId: rowData.id, // existing booking ID
          reason: result.value, // user input from the modal
        };

        axios
          .post(`${baseUrl}/api/reschedule/student/create`, payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            Swal.fire({
              html: `
    <h4 style="font-size:16px; margin-bottom: 10px;">Rescheduled!</h2>
    <p style="font-size:16px;">The reschedule request has been sent to the counselor. We will inform you once it is processed.</p>
  `,
              icon: "success",
            });

            // Swal.fire(
            //   "Rescheduled!",
            //   "The reschedule request has been sent to counselor. We will inform you once it is processed",
            //   "success"
            // );
            fetchData(); // refresh the table/list if needed
          })
          .catch((error) => {
            console.error("Reschedule error:", error);
            const message =
              error.response?.data?.message ||
              error.message ||
              "Failed to reschedule.";
            Swal.fire("Error", message, "error");
          });
      }
    });
  };
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("meet_link", {
      header: "Google Meet Link",
      size: 30,
      Cell: (cell) => {
        const link = cell.row.original?.meet_link;
        const rescheduleId = cell.row.original?.rescheduleId;

        if (rescheduleId) return "-";
        if (!link) return "-";

        const handleCopy = async () => {
          try {
            await navigator.clipboard.writeText(link);
            toast.success("Link copied to clipboard!");
            // alert("Link copied to clipboard!");
          } catch (err) {
            console.error("Failed to copy:", err);
          }
        };

        return (
          <Stack direction="row" spacing={1}>
            <Tooltip title="Copy Link">
              <IconButton size="small" onClick={handleCopy}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Open Link">
              <IconButton
                size="small"
                onClick={() => window.open(link, "_blank")}
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    }),

    columnHelper.accessor("c_firstname", {
      header: "Counselor Name",
      size: 40,
      Cell: (cell) =>
        cell.row.original?.c_firstname + " " + cell.row.original?.c_lastname,
    }),

    columnHelper.accessor("booking_date", {
      header: "Slot Date (UTC)",
      size: 20,
      // Cell: (cell) => cell.row.original?.booking_date?.split("T")[0],
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("start_time", {
      header: "Start time (UTC)",
      size: 20,
      // Cell: (cell) => cell.row.original?.start_time || "--",
      Cell: (cell) => formatUtcTimeTo12Hour(cell.row.original.utcTime),
    }),
    columnHelper.accessor("end_time", {
      header: "End time (UTC)",
      size: 20,
      // Cell: (cell) => cell.row.original?.end_time || "--",
      Cell: (cell) => formatUtcTimeTo12HourAdd1hour(cell.row.original.utcTime),
    }),

    columnHelper.accessor("booking_date", {
        id: "booking_date_local",
      header: `Slot Date (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.booking_date?.split("T")[0],
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"date"),
    }),
    columnHelper.accessor("start_time", {
       id: "start_time_local",
      header: `Start time (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.start_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"start"),
    }),
    columnHelper.accessor("end_time", {
       id: "end_time_local",
      header: `End time(${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.end_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"end"),
    }),

    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   size: 20,
    //   Cell: (cell) => cell.row.original?.created_at?.split("T")[0],
    // }),
    columnHelper.accessor("reqId", {
      header: "Request ID",
      size: 20,
      Cell: (cell) => "DDR000" + cell.row.original?.reqId,
    }),
  ];

  columns.unshift(
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowData = cell.row.original;
        const status = rowData.status;
        const rescheduleId = rowData.rescheduleId;
        const bookingDate = rowData.booking_date;
        const bookingTime = rowData.start_time;
        const newbookedId = rowData.newbookedId;

        // Combine with moment
        const bookingDateTime = moment(
          `${bookingDate} ${bookingTime}`,
          "YYYY-MM-DD hh:mm A"
        ).toDate();

        // 24 hours before slot
        const cutoffDateTime = new Date(
          bookingDateTime.getTime() - 24 * 60 * 60 * 1000
        );

        const now = new Date();
        const canReschedule = now < cutoffDateTime;

        return (
          <Box>
            {rescheduleId && status == 0 ? (
              <Button
                variant="outlined"
                color="success"
                size="small"
                disabled
                sx={{ textTransform: "none" }}
              >
                In-Progress approval
              </Button>
            ) : rescheduleId && status == 2 && !newbookedId ? (
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#28a745", color: "white" }}
                onClick={() => {
                  navigate("/student-slot-booking", {
                    state: {
                      counselorId: rowData.counselorId,
                      studentId: rowData.studentId,
                      reqId: rowData.reqId,
                      UnscheduledSlot: 1,
                      rescheduleId: rowData.rescheduleId,
                    },
                  });
                }}
              >
                Reschedule Slot
              </Button>
            ) : canReschedule && !newbookedId ? (
              <Tooltip title="Reschedule" arrow>
                <IconButton
                  onClick={() => handleReschedule(rowData)}
                  sx={{ color: "red" }}
                >
                  <EventRepeatIcon />
                </IconButton>
              </Tooltip>
            ) : rescheduleId && status == 2 && newbookedId ? (
              <Button
                variant="outlined"
                color="success"
                size="small"
                disabled
                sx={{ textTransform: "none" }}
              >
                Already Rescheduled
              </Button>
            ) : (
              <Tooltip title="Reschedule" arrow>
                <IconButton sx={{ color: "red" }} disabled>
                  <EventRepeatIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    })
  );

  return (
    <MasterLayout>
      <>
        <ToastContainer position="top-right" autoClose={2000} />
        <CustomTable columns={columns} data={data} loading={loading} />
      </>
    </MasterLayout>
  );
}
